import { Empty, Modal } from '@arco-design/web-react';
import { IconEyeInvisible } from '@arco-design/web-react/icon';
import type { StandardAttachmentFile } from './StandardAttachment';
import { standardAttachmentType } from './StandardAttachment';

export function AttachmentPreviewModal<T extends StandardAttachmentFile>({
  file,
  visible,
  onClose,
}: {
  readonly file?: T;
  readonly visible: boolean;
  readonly onClose: () => void;
}) {
  const type = file ? standardAttachmentType(file.name) : 'other';
  return <Modal className="standard-attachment-preview-modal" footer={null}
    title={file ? `附件预览 · ${file.name}` : '附件预览'} unmountOnExit
    visible={visible} onCancel={onClose}>
    <div className="standard-attachment-preview__viewer">
      {!file?.previewUrl ? (
        <Empty icon={<IconEyeInvisible />} description="该附件暂不支持在线预览" />
      ) : type === 'image' ? (
        <img className="standard-attachment-preview__image" src={file.previewUrl} alt={file.name} />
      ) : type === 'pdf' ? (
        <iframe className="standard-attachment-preview__frame" src={file.previewUrl}
          title={`${file.name} 附件预览`} />
      ) : (
        <Empty icon={<IconEyeInvisible />}
          description="该文件类型暂不支持在线预览，请下载后查看" />
      )}
    </div>
  </Modal>;
}
